/* eslint-disable @typescript-eslint/no-unused-vars */
import Color from "color";
import { blue } from "tailwindcss/colors";

const alpha = (clr, val) => Color(clr).alpha(val).rgb().string();
const lighten = (clr, val) => Color(clr).lighten(val).rgb().string();
const darken = (clr, val) => Color(clr).darken(val).rgb().string();

export const tailwindConfigModule = {
    darkMode: "selector",
    content: ["./src/**/*.{html,jsx,tsx}"],
    theme: {
        extend: {
            colors: {
                primary: {
                    main: "#9d3dff", // Kovr default, modify later
                    50: "#faf5ff",
                    100: "#f3e7ff",
                    200: "#e8d3ff",
                    300: "#d7b0ff",
                    400: "#be7eff",
                    500: "#9d3dff",
                    600: "#8f2af3",
                    700: "#7c1ad6",
                    800: "#691aaf",
                    900: "#57178c",
                    950: "#3a0269",
                },
                secondary: {
                    main: "#01BDAC",
                },
                textSecondary: {
                    light: "#6b7280",
                    dark: "#BBBDC1",
                },
                base: {
                    light: "#ffffff",
                    dark: "#151521",
                },
                surface: {
                    light: "#ffffff",
                    hoverLight: blue[50],
                    dark: "#1e1e2d",
                    hoverDark: lighten("#1e1e2d", 0.25),
                },
                "surface-active": {
                    light: "#f2f4f8",
                    dark: "#14121f",
                },
                "surface-highlight": {
                    light: "#f2f4f8",
                    dark: "#323248",
                },
                divider: "var(--divider-color)",
            },
        },
    },
    plugins: [],
};

export default tailwindConfigModule;
